import { NgModel } from '@angular/forms';
import { Directive, HostListener, Input, ElementRef, OnInit } from '@angular/core';
import { isNotNull } from '../../util/check';
import { FnNumberDirective } from './fn-number.directive';


@Directive({
    selector: '[fnCurrencyDirective]',
    providers: [NgModel]
})
export class FnCurrencyDirective extends FnNumberDirective implements OnInit {
    @Input() format = '$';
    private whiteSpace = ' ';

    @HostListener('blur', ['$event.target.value'])
    override onBlur(value: any) {
        if (this.model.valid && isNotNull(value) && value !== '') {
            value = this.removeFromat(value);
            this.model.valueAccessor.writeValue(this.format + this.whiteSpace + String(parseFloat(value).toFixed(2)));
        }
    }


    @HostListener('focus', ['$event.target.value']) onFocus(value: any) {
        this.nativeElement.focus();
        if (this.model.valid && isNotNull(value) && value !== '') {
            value = this.removeFromat(value);
            this.model.valueAccessor.writeValue(value);
            this.nativeElement.setSelectionRange(value.length, value.length);
        }
    }
    constructor(model: NgModel, elementRef: ElementRef) {
        super(model, elementRef);
        this.isDecimal = true;
    }
    override ngOnInit() {
        setTimeout(() => {
            // this.onBlur(this.elementRef.nativeElement.getAttribute('ng-reflect-model'));
            this.onBlur(this.elementRef.nativeElement.value);
        })
    }
    private removeFromat(value: string) {
        return String(parseFloat(value.replace(this.format, '').replace(this.whiteSpace, '')));
    }
}
